"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateOAuthClientSchema () {
        return CreateOAuthClientSchema;
    },
    get UpdateOAuthClientSchema () {
        return UpdateOAuthClientSchema;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _nocodbsdk = require("nocodb-sdk");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const CreateOAuthClientSchema = _zod.default.object({
    client_name: _zod.default.string().min(1, 'Client name is required').max(255, 'Client name must be less than 255 characters').trim(),
    client_type: _zod.default.nativeEnum(_nocodbsdk.OAuthClientType, {
        errorMap: ()=>({
                message: 'Client type must be either "confidential" or "public"'
            })
    }).default(_nocodbsdk.OAuthClientType.PUBLIC).optional(),
    fk_user_id: _zod.default.string().optional(),
    client_uri: _zod.default.string().url('Invalid client URI format').optional().or(_zod.default.literal('')),
    client_description: _zod.default.string().max(500, 'Description must be less than 500 characters').optional(),
    logo_uri: _zod.default.record(_zod.default.string(), _zod.default.unknown()).optional(),
    redirect_uris: _zod.default.array(_zod.default.string().url('Each redirect URI must be a valid URL')).min(1, 'At least one redirect URI is required'),
    allowed_grant_types: _zod.default.array(_zod.default.enum([
        'authorization_code',
        'refresh_token'
    ], {
        errorMap: ()=>({
                message: 'Invalid grant type'
            })
    })).default([
        'authorization_code',
        'refresh_token'
    ]).optional(),
    response_types: _zod.default.array(_zod.default.enum([
        'code',
        'token',
        'id_token'
    ], {
        errorMap: ()=>({
                message: 'Invalid response type'
            })
    })).optional(),
    allowed_scopes: _zod.default.string().max(1000, 'Scopes string too long').optional(),
    registration_client_uri: _zod.default.string().url('Invalid registration client URI format').optional(),
    registration_access_token: _zod.default.string().optional(),
    client_id_issued_at: _zod.default.number().optional(),
    client_secret_expires_at: _zod.default.number().optional()
});
const UpdateOAuthClientSchema = _zod.default.object({
    client_name: _zod.default.string().min(1, 'Client name is required').max(255, 'Client name must be less than 255 characters').trim().optional(),
    client_uri: _zod.default.string().optional().or(_zod.default.literal('')),
    client_description: _zod.default.string().max(500, 'Description must be less than 500 characters').optional(),
    logo_uri: _zod.default.record(_zod.default.string(), _zod.default.unknown()).optional(),
    redirect_uris: _zod.default.array(_zod.default.string().url('Each redirect URI must be a valid URL')).min(1, 'At least one redirect URI is required').optional(),
    allowed_grant_types: _zod.default.array(_zod.default.enum([
        'authorization_code',
        'refresh_token',
        'client_credentials',
        'password'
    ])).optional(),
    response_types: _zod.default.array(_zod.default.enum([
        'code',
        'token',
        'id_token'
    ])).optional(),
    allowed_scopes: _zod.default.string().max(1000, 'Scopes string too long').optional(),
    registration_client_uri: _zod.default.string().url('Invalid registration client URI format').optional(),
    client_secret_expires_at: _zod.default.number().optional()
});
